module.exports = __webpack_public_path__ + "assets/media/policy.6f35d15c.svg";